import { CopyToClipboardButton, Text } from '@dixa/lib-shared-habla';
import { ReactNode } from 'react';

import styles from './detailField.module.scss';

export type DetailField = {
  readonly label: string;
  readonly value: ReactNode;
  /** When set, renders a copy-to-clipboard button next to the value. */
  readonly copyText?: string;
};

export const hasValue = (field: DetailField): boolean =>
  field.value !== undefined && field.value !== null && field.value !== '';

/**
 * A single label-above-value column (left-aligned, wrapping) — one entry of
 * the detail layout shown when a Customer Activities card is expanded.
 */
export const DetailField = ({
  label,
  value,
  copyText,
}: DetailField): JSX.Element => (
  <div className={styles.field}>
    <Text.Paragraph as="span" variant="4" subdued>
      {label}
    </Text.Paragraph>
    <span className={styles.value}>
      <Text.Paragraph as="span" variant="3">
        {value}
      </Text.Paragraph>
      {copyText && (
        <CopyToClipboardButton
          textToCopy={copyText}
          buttonProps={{ icon: 'copy', variant: 'tertiary' }}
        />
      )}
    </span>
  </div>
);
